export const dealerPortalStyle = "bg-[#78C15A] font-semibold text-white p-3 cursor-pointer";
